<div class="header">
  <div class="header-navigation">
    <ul>
      @for (pageDefinition of _pages; track $index) {
      <li
        appTooltip
        [appTooltip]="pageDefinition.title"
        tooltipPosition="left"
        class="nav-item"
        [ngClass]="{ 'sidebar-page_active': pageDefinition.active }"
        [ngStyle]="
          $last || pageDefinition.position == 'end' ? { 'margin-left': 'auto' } : {}
        "
      >
        <button
          (click)="_openPage.emit(pageDefinition)"
          [disabled]="pageDefinition.disabled"
          [ngStyle]="{ width: '100%', height: '100%' }"
        >
          <span><i [class]="pageDefinition.className"></i></span>
        </button>
      </li>
      }
    </ul>
  </div>

  @if (headerService.headerDetails(); as headerDefinition) {
    <div
    class="header-actions"
  >
    <div style="place-self: center start" class="back-button-container">
      @if(headerDefinition.backButton)
      {
        <button
        appTooltip="Back"
        tooltipPosition="left"
        class="flex-center header_action"
        [routerLink]="headerDefinition.backRoute"
        ><i class="fa fa-arrow-left"></i
      ></button>
      }
    </div>
    <h3 style="margin: 0; place-self: center center; text-align: center">
      {{ headerDefinition.title }}
    </h3>
    <button
      appTooltip="Collapse Sidebar"
      tooltipPosition="left"
      class="flex-center header_action"
      style="place-self: center end"
      (click)="close()"
    >
      <i class="fa fa-angle-double-right"></i>
    </button>
  </div>
  }


</div>
